/* eslint-disable react/prop-types */
/* eslint-disable import/no-named-as-default */
import React, { useState, useContext, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Redirect, useParams } from "react-router-dom"
import * as resetPasswordActions from "../../actions/resetPasswordActions"
import * as appActions from "../../actions/appActions"
import { i18n } from "../i18n"
import _ from "lodash"

import { Paper, TextField, Typography, Button } from "@material-ui/core"
import { Grid } from "@mui/material"

const ResetPassword = () => {
  const dispatch = useDispatch()
  const base = location.pathname.split("/")[1].toUpperCase()
  const brand = base.toLowerCase()
  const { token } = useParams()
  const isFetching = useSelector((state) => state.resetPassword.isFetching);
  const [redirect, setRedirect] = useState(false)
  const success = useSelector((state) => state.resetPassword.success);
  const isValidResetToken = useSelector((state) => state.resetPassword.isValidResetToken);
  const [password, setPassword] = useState("")
  const [cPassword, setCPassword] = useState("")

  const labelContext = useContext(i18n)
  const getLabel = (label, defaultValue) => {
    if (i18n !== undefined) {
      return _.get(labelContext, `labels.${label}`, defaultValue)
    } else {
      return defaultValue
    }
  }

  useEffect(() => {
    if(isValidResetToken === undefined) {
      dispatch(resetPasswordActions.validateResetPasswordToken(token, base.toUpperCase()))
    } 
  }, [])

  function handleReset(e) {
    e.preventDefault()
    if (password !== cPassword) {
      dispatch(appActions.showMessage("Request Error", "The new password doesn't match", "danger"))
    } else if(password === "") {
      dispatch(appActions.showMessage("Request Error", "The password cannot be blank", "danger"))
    } else {
      dispatch(resetPasswordActions.resetPassword(token, password, cPassword))
    }
  }

  function backToLogin(e) {
    e.preventDefault();
    dispatch(resetPasswordActions.clearResetPassword())
    setRedirect(true)
  }

  if(redirect === true || isValidResetToken === false) {
    return <Redirect to={`/${base}/login`} />
  }

  if (!isFetching && success === true) {
    return (<Grid
      container
      style={{
        backgrounColor: "#ccc",
        height: "100vh",
        backgroundImage: 'url("https://static.hertz.asiapac.io/portal/img/HZ25_120_OBTSiteBanner.jpg")',
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat"
      }}
      justifyContent="flex-end"
    >
      <Grid
        container
        item
        style={{ width: "650px", backgroundColor: "#000", opacity: "0.8" }}
        justifyContent="center"
        alignItems="center"
      >
        <Paper style={{ width: "550px", height: "600px", padding: "30px 20px", background: "#e0dada" }}>
          <Grid container direction="row" justifyContent="center" alignItems="flex-start" style={{ margin: "25px 0px" }}>
            <img src={`https://static.hertz.asiapac.io/mybookingportal/${brand}-dark-logo.png`} height="80px" />
          </Grid>
          <Typography variant="h4">Reset Password</Typography>
          <Typography variant="body1">The password has been reset</Typography>
          <Button
            type="submit"
            onClick={backToLogin}
            color="secondary"
            size="large"
            variant="contained"
          >
            Back To Login
          </Button>
          <Grid container direction="row" justifyContent="center" alignItems="flex-start" style={{ marginTop: 50 }}>
            <img src={`${"/i18n/hertzlogo-dark.png"}`} height="50px" />
          </Grid>
        </Paper>
      </Grid>
    </Grid>)
  }

  return (
    
    <Grid
      container
      style={{
        backgrounColor: "#ccc",
        height: "100vh",
        backgroundImage: 'url("https://static.hertz.asiapac.io/portal/img/HZ25_120_OBTSiteBanner.jpg")',
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat"
      }}
      justifyContent="flex-end"
    >
      { (
        <Grid
          container
          item
          style={{ width: "650px", backgroundColor: "#000", opacity: "0.7" }}
          justifyContent="center"
          alignItems="center"
        >
          <Paper style={{ width: "550px", height: "600px", padding: "30px 20px" }}>
            <Grid container direction="row" justifyContent="center" alignItems="flex-start" style={{ margin: "25px 0px" }}>
              <img src={`https://static.hertz.asiapac.io/mybookingportal/${brand}-dark-logo.png`} height="80px" />
            </Grid>
            <Typography variant="h4">Reset Password</Typography>
            <form>
              <Grid item xs={12}>
                <TextField
                  id="pasword"
                  label={getLabel("login.Password", "Password")}
                  value={password}
                  type="password"
                  onChange={(e) => setPassword(e.target.value)}
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="passwordConfirm"
                  label={"Confirm Password"}
                  value={cPassword}
                  type="password"
                  onChange={(e) => setCPassword(e.target.value)}
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid container item xs={12} justifyContent="flex-end">
                <Button
                  type="submit"
                  color="secondary"
                  size="large"
                  variant="contained"
                  onClick={(e) => handleReset(e)}
                >
                  Submit{" "}
                </Button>
              </Grid>
              <Grid container direction="row" justifyContent="center" alignItems="flex-start" style={{ marginTop: 50 }}>
                <img src={`${"/i18n/hertzlogo-dark.png"}`} height="50px" />
              </Grid>
            </form>
          </Paper>
        </Grid>
      )}
    </Grid>
  )
}

export default ResetPassword
